import styled from '@emotion/styled';
import { Colors, Fonts } from '@paddl/storybook';

const {
  white,
  grey_lighter
} = Colors;

const {
  H3
} = Fonts;

export const ContentWrapper = styled.div`
  background: ${({ breakpoint }) => (breakpoint === 'xs' ? grey_lighter : white)};
  display: flex;
`;

export const ProfileInnerContentWrapper = styled.div`
  width: 100%;
  background: ${white};
  overflow: auto;
  height: ${({ breakpoint }) => (breakpoint === 'xs' && breakpoint === 'sm'? 'auto' : 'calc(100vh - 198px)')};
`;

export const InnerActivityWrapper = styled.div`
  box-sizing: border-box;
  padding: 16px;
  max-width: 680px;
  width: ${({ breakpoint }) => (breakpoint === 'xs' && '100%')};
  margin: ${({ breakpoint }) => (breakpoint === 'xs' ? '16px auto 0' : '0 auto')};
  overflow: auto;

  > section {
    margin-bottom: 24px;
    border-radius: 4px;
    transition: background 0.25s ease;

    .headline {
      ${H3};
      margin: 0 0 20px 0;
    }
  }
`;

export const VerifiedPanelWrapper = styled.div`
  margin-top: 36px;
  padding: 16px;
  border-top: 1px solid ${grey_lighter};
  border-bottom: 1px solid ${grey_lighter};
`;

export const SignupPromoWrapper = styled.div`
  margin-top: 36px;
`;
